import { Button } from '@mui/material'

import type { TextButtonProps } from './TextButton.types'

const TextButton = ({ height = '58px', radius = '18px', sx, ...props }: TextButtonProps) => {
  return (
    <Button
      variant="text"
      sx={{
        height,
        borderRadius: radius,
        fontSize: '16px',
        fontWeight: 500,
        textTransform: 'none',
        color: '#464A54',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        paddingX: 4.5,
        ...sx,
      }}
      {...props}
    />
  )
}

export default TextButton
